import { usePipelineTemplateQuery, useCreatePipelineTemplateMutation, useUpdatePipelineTemplateMutation, useDeletePipelineTemplateMutation } from './usePipelineTemplatesQuery';
import { PipelineTemplate } from '../types';

export const usePipelineTemplate = (pipelineTemplateId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = usePipelineTemplateQuery(pipelineTemplateId || '');
    const createPipelineTemplateMutation = useCreatePipelineTemplateMutation();
    const updatePipelineTemplateMutation = useUpdatePipelineTemplateMutation();
    const deletePipelineTemplateMutation = useDeletePipelineTemplateMutation();

    const createRecord = async (values: PipelineTemplate) => {
        return await createPipelineTemplateMutation.mutateAsync(values);
    };

    const updateRecord = async (values: PipelineTemplate) => {
        if (typeof pipelineTemplateId === 'undefined') {
            throw new Error('pipelineTemplateId is required parameter');
        }
        return await updatePipelineTemplateMutation.mutateAsync({ id: pipelineTemplateId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof pipelineTemplateId === 'undefined') {
            throw new Error('pipelineTemplateId is required parameter');
        }
        return await deletePipelineTemplateMutation.mutateAsync(pipelineTemplateId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
